export const unmarshal = (data, Model) => {
	const instance = new Model();
	Object.assign(instance, data);
	return instance;
};

